import React from 'react';
import HorizontalScrollHint from '../HorizontalScrollHint';
import {
  countItemsWithLabel,
  countItemsWithoutLabels,
  ENTITY_LABEL_FILTER_UNLABELED,
  ENTITY_LABEL_FILTER_UNLABELED_DISPLAY,
} from '../../shared/utils/entityLabelFilter';

function EntityLabelChip({ label, count, active, onClick }) {
  return (
    <button
      type="button"
      className={`entity-label-filter-chip${active ? ' active' : ''}`}
      onClick={onClick}
      aria-pressed={active}
    >
      <span className="entity-label-filter-chip__label" title={label}>
        {label}
      </span>
      <span className="entity-label-filter-chip__count">({count})</span>
    </button>
  );
}

/**
 * Per–object-type label filter chips (inline labels on items; no label DB).
 */
export default function EntityLabelFilterBar({
  items,
  labelField = 'labels',
  activeLabel,
  onActiveLabelChange,
  labelOptions,
  ariaLabel = 'Label filter',
  showUnlabeledFilter = false,
}) {
  const totalCount = Array.isArray(items) ? items.length : 0;
  const unlabeledCount = countItemsWithoutLabels(items, labelField);

  return (
    <div className="entity-label-filter-bar" role="group" aria-label={ariaLabel}>
      <HorizontalScrollHint
        className="h-scroll-hint--surface"
        scrollerClassName="entity-label-filter-bar__list"
      >
        <button
          type="button"
          className={`entity-label-filter-chip${activeLabel == null ? ' active' : ''}`}
          onClick={() => onActiveLabelChange(null)}
          aria-pressed={activeLabel == null}
        >
          <span className="entity-label-filter-chip__label">All</span>
          <span className="entity-label-filter-chip__count">({totalCount})</span>
        </button>
        {(labelOptions || []).map((name) => (
          <EntityLabelChip
            key={name}
            label={name}
            count={countItemsWithLabel(items, name, labelField)}
            active={activeLabel === name}
            onClick={() => onActiveLabelChange(name)}
          />
        ))}
        {showUnlabeledFilter ? (
          <EntityLabelChip
            label={ENTITY_LABEL_FILTER_UNLABELED_DISPLAY}
            count={unlabeledCount}
            active={activeLabel === ENTITY_LABEL_FILTER_UNLABELED}
            onClick={() => onActiveLabelChange(ENTITY_LABEL_FILTER_UNLABELED)}
          />
        ) : null}
      </HorizontalScrollHint>
    </div>
  );
}
